// Ordenamiento de tablas por columna (cliente) reutilizable en el módulo financiero.
import { useState } from 'react';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

type SortDir = 'asc' | 'desc';
export interface SortState { key: string; dir: SortDir }

export function useSort<T>(rows: T[]) {
  const [sort, setSort] = useState<SortState | null>(null);
  const toggle = (key: string) =>
    setSort((s) => (s && s.key === key ? { key, dir: s.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' }));
  if (!sort) return { sorted: rows, sort, toggle };
  const f = sort.dir === 'asc' ? 1 : -1;
  const sorted = [...rows].sort((a, b) => {
    const va = (a as Record<string, unknown>)[sort.key];
    const vb = (b as Record<string, unknown>)[sort.key];
    if (va == null && vb == null) return 0;
    if (va == null) return 1;          // nulos al final
    if (vb == null) return -1;
    if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * f;
    return String(va).localeCompare(String(vb), 'es', { numeric: true }) * f;
  });
  return { sorted, sort, toggle };
}

export function SortableTh({ col, label, align = 'left', sort, onSort, className = '' }: {
  col: string; label: string; align?: 'left' | 'right' | 'center';
  sort: SortState | null; onSort: (k: string) => void; className?: string;
}) {
  const active = sort?.key === col;
  const alignCls = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';
  const just = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start';
  return (
    <th className={`py-2 pr-3 ${alignCls} ${className}`}>
      <button type="button" onClick={() => onSort(col)}
        className={`inline-flex w-full items-center gap-1 ${just} hover:text-foreground ${active ? 'text-foreground font-medium' : ''}`}>
        {label}
        {active
          ? (sort!.dir === 'asc' ? <ArrowUp className="w-3 h-3 shrink-0" /> : <ArrowDown className="w-3 h-3 shrink-0" />)
          : <ArrowUpDown className="w-3 h-3 shrink-0 opacity-40" />}
      </button>
    </th>
  );
}
